import { Injectable, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
// Angular service that leverages the home-targeted-zone flow code to render zones for Angular components.
export class ZoneRendererService {
  private zoneComponent: any;
  private window: Window; 
  private populateZone: Function = null; 
  private bootstrapAngular: Function = null;

  constructor(@Inject(DOCUMENT) private document: Document) { 
    this.window = this.document.defaultView || window;
    this.zoneComponent = this.window['zoneTargetedContentV2Comp'];
    this.populateZone = this.zoneComponent ? this.zoneComponent.populateZone.bind(this.zoneComponent) : null;
    this.bootstrapAngular = this.zoneComponent ? this.zoneComponent.bootstrapAngular.bind(this.zoneComponent) : null;
  }

  // Expects the data from gridZone to already be in the format of {items: []}
  public renderGridZone(zoneRef: HTMLElement, componentData: any, isGridWithFacets: boolean = false): void {
    if (!this.populateZone) return;

    if (this.isSponsoredCarousel(componentData?.items?.[0])) {
      const parentElement = zoneRef.parentElement;

      if (parentElement) {
        // Create new carousel element
        const carouselContainer = this.document.createElement('div');
        const rowId = zoneRef.id;
        carouselContainer.innerHTML = this.generateSpaCarouselInnerHtml(componentData.items?.[0], rowId);

        // Insert the new carousel
        parentElement.appendChild(carouselContainer);
        // Remove the original zoneRef if needed
        zoneRef.remove();
        // Fix dependency on some zone 0 component calling bootstrapAngular first before we enter here. 
        if (this.bootstrapAngular) {
          this.bootstrapAngular();
        }

        return; // Skip populateZone
      }
    }
    // Populate zone has a generic format where it can support multiple components for one zone. 
    // This is why we can pass the entire componentData object.
    // Unlike the spaCarousel above, where we need to pass in a singular item for the data.
    this.zoneComponent.wrapperName = 'targeted-wrapper';
    this.zoneComponent.wrapperAttribute = 'data-targeted-component';
    this.populateZone(zoneRef, componentData, true, isGridWithFacets);
  }

  private normalizeCarouselTitle(carouselTitle: string | null | undefined): string {
    return (carouselTitle ?? '').replace(/\s+/g, ' ').trim();
  }

  private generateSpaCarouselInnerHtml(carouselConfig: any, idName: string): string {
    const products = (JSON.stringify(carouselConfig).replace(/'/g, "&apos;"));
    const carouselTitle = this.normalizeCarouselTitle(carouselConfig?.carouselTitle);
    return `<div class="col-12 bia-spa-carousel-container sponsored-container">
      <span class="bia-spa-carousel-container-header">${carouselTitle}</span>
      <div id=${idName}>
        <div class="slick-product-carousel">
          <targeted-wrapper
            data-targeted-component="product-carousel"
            data-home-targeted="true"
            data-carousel-type="generic-products"
            data-carousel-title="${carouselTitle}"
            data-carousel-users="${carouselConfig.hideOnLoading == 'mask' ? carouselConfig.userType : 'false'}"
            data-carousel-action="${carouselConfig.actionButton == null ? 'qty-stepper' : carouselConfig.actionButton}"
            data-carousel-behaviour="bia-spaCarousel"
            data-experimentation="${carouselConfig.webExperimentation || ''}"
            data-experimentation-id="${carouselConfig.webExperimentationId || ''}"
            data-experimentation-type="${carouselConfig.webExperimentationType || ''}"
            data-impression-tracking="${carouselConfig.webIsImpTrackEnabled || ''}"
            data-products='${products}'
            data-carousel-max-products="${carouselConfig.maxNumOfProducts || ''}"
            data-navigation-type="${carouselConfig.navigationType || ''}"
            data-cart-type="${carouselConfig.cartType || ''}"
            data-filter-cart-items="${carouselConfig.filterCartItems || ''}"
            data-seller-type="${carouselConfig.sellerType || ''}"
            data-carousel-pdp="false"
            data-is-dynamic-grid-flow="true"
            id="${carouselConfig.itemName || ''}">
          </targeted-wrapper>
        </div>
      </div>
    </div>`;
  }


  public isSponsoredCarousel(zoneData: any): boolean {
    if (zoneData?.type === 'master-product-carousel' && zoneData?.modelId === '650a2c73537e397683690448') {
      return true;
    }
    return false;
  }
}
